import { lazy } from "react";

export { DYNAMIC_REQUESTS_PATH } from "./dynamic-requests-path";

export const DynamicRequestsPage = lazy(() => import("./dynamic-requests"));
